
import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import Favourite from '@models/games/Favourite';
import IFavoriteDto from './dtos/IFavoriteDto';

export default class FavoriteMapper extends AbstractMapper<IFavoriteDto, Favourite> {
    createTargetObject(game: IFavoriteDto): Favourite {
        const stateGame = new Favourite();
        stateGame.gameId = game.GameId;
        return stateGame;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/game/FavoriteMapper.ts